import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[
    'een-button',
    {
      isIcon: _vm.icon,
      hasAppendIcon: _vm.appendIcon,
      small: _vm.small,
      'een-button__small-padding': _vm.smallPadding
    },
    (!_vm.loading && _vm.color) && (_vm.color + 'Btn'),
    (!_vm.loading && _vm.type) && (_vm.type + 'Btn'),
    !_vm.loading
      ? {
        disabled: _vm.disabled,
        onImage: _vm.onImage,
        map: _vm.map,
      }
      : 'loading-button',
    { block: _vm.block },
    { overlay: _vm.overlay },
    { 'overlay-disabled' : _vm.overlay && _vm.disabled}],on:{"click":e => _setup.buttonClick(e)}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.text)+" ")]}),(_vm.appendIcon && !_vm.loading)?_c(VIcon,{attrs:{"right":"","size":_vm.iconSize,"color":_vm.iconColor}},[_vm._v(" "+_vm._s(_vm.appendIcon)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }